import { IProductImage } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import ThumbMailSlider from "./slider-with-thumbmails/ThumbMailSlider";
import { useRef } from "react";
import { getWidthFromDivElement } from "@/utils/functions/functions";
import NextImage from "@/app/components/lib/NextImage";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import PreviewProvider from "./PreviewProvider";
import MediaPreviewModal from "@/app/components/lib/media-preview-provider/MediaPreviewModal";
import PlayVideoIcon from "@/app/components/common-builder/gallery/PlayVideoIcon";

interface Props {
  productImages: IProductImage[];
  id: number;
  isPC: boolean;
  isSmall?: boolean;
  productName: string;
}

const SliderWithThumbs: React.FC<Props> = ({
  productImages,
  isPC,
  id,
  isSmall = false,
  productName,
}) => {
  const getCompany = useGetCompanyQuery();
  const ratio =
    getCompany?.data?.result?.theme?.components?.product?.image_ratio ?? 1;
  const containerRef = useRef<HTMLDivElement>(null);
  const size = isSmall ? 48 : 137;
  // (size + 12) because of spasing in ThumbMailSlider!!
  const thumbMails = isPC ? productImages?.map((im) => ({ ...im })) : [];
  const thumbnailsWidth =
    thumbMails?.length > 1 ? size - (isSmall ? 8 : 16) : 0;
  const sliderWidth = getWidthFromDivElement(containerRef) - thumbnailsWidth;

  const videoPreviewRef = useRef<{
    showMedia(src: string, type: "video" | "image"): void;
  } | null>(null);

  const imagesUrl = productImages
    .filter((m) => m.type === "image")
    .map((item) => item.image_url);

  return (
    <div ref={containerRef} className="w-100">
      <PreviewProvider images={imagesUrl}>
        {(openGallery) => (
          <ThumbMailSlider
            thumbnails={thumbMails}
            id={id}
            size={size}
            isSamll={isSmall}
            sliderWidth={sliderWidth}
            ratio={ratio}
          >
            {productImages?.map((img, key) => (
              <div
                key={key}
                // className="unset-img"
                style={{
                  borderRadius: 16,
                  display: "block",
                  margin: "auto",
                  textAlign: "center",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                {img?.type === "video" && (
                  <PlayVideoIcon
                    style={{
                      position: "absolute",
                      top: "45%",
                      left: "45%",
                      zIndex: 5,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      videoPreviewRef.current?.showMedia(
                        img.image_url,
                        img?.type ?? "image",
                      );
                    }}
                  />
                )}
                <NextImage
                  priority
                  alt={`${productName} image ${key}`}
                  src={
                    img?.type === "image" ? img.image_url : img.thumbnail_url
                  }
                  width={sliderWidth}
                  height={sliderWidth * ratio}
                  // layout="fill"
                  // className="custom-img"
                  onClick={() => {
                    if (img?.type === "image") {
                      const imageIndex = imagesUrl.findIndex(
                        (mUrl) => mUrl === img.image_url,
                      );
                      return openGallery(imageIndex);
                    }
                    videoPreviewRef.current?.showMedia(
                      img.image_url,
                      img?.type ?? "image",
                    );
                  }}
                  objectFit="contain"
                />
              </div>
            ))}
          </ThumbMailSlider>
        )}
      </PreviewProvider>
      <MediaPreviewModal ref={videoPreviewRef} />
    </div>
  );
};

export default SliderWithThumbs;
